import { _elements } from './_elements';
import { _scroll } from './_scroll';

/*
 * This function navigates to the next-item.
 */
export const _next = ( { target } ) => {
	const {
		slider,
		current,
		items,
	} = _elements( target.closest( '[data-slider]' ) );

	const next = items[ current + 1 ];

	if ( next ) {
		_scroll( slider, next );
	}
};
